import styled from 'styled-components';

export const ListTableWrapper = styled.div`
    position: relative;
`;

export const ListWrapper = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin: 0;
    padding: 0;
`;
